<template>
  <div class="mirror-wrapper">
    <div v-if="this.formattedPrograms" class="products">
      <div class="header">
        <div class="header-title">Lista de Programas</div>
      </div>
      <div class="mirror-panels">
        <v-expansion-panels flat multiple v-model="placePanels">
          <v-expansion-panel
            v-for="(programList, place) in this.formattedPrograms"
            :key="place"
          >
            <v-expansion-panel-header ripple>
              <div class="place-title">{{ place }}</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pl-0 pr-0">
              <ul class="products-list">
                <li
                  v-for="(item, index) in programList"
                  :key="index"
                  class="products-list-item"
                  :class="{ 'product-list-item--active': item.active }"
                  @click="openMirror(item.place, item.program_tag)"
                  ripple
                >
                  <div class="product-thumb">
                    <img v-if="item.program_image" :src="item.program_image" />
                    <img
                      v-else
                      src="@/assets/images/mirror-default-banner.png"
                    />
                  </div>
                  <div class="product-name">{{ item.program_name }}</div>
                </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { actions, categories } from '@/constants/analytics.js';

export default {
  name: 'MirrorPreviewWrapper',
  data() {
    return {
      placePanels: [],
    };
  },
  created() {
    this.loadPrograms();
  },
  computed: {
    ...mapState({
      programs: state => state.mirror.programs,
    }),
    formattedPrograms() {
      if (!this.programs) return {};
      //loop through items to check if the
      // user exists inside one or more programs
      let tempPrograms = {};
      this.programs.forEach(item => {
        const { category } = item;
        const tempProgram = {
          place: item.place,
          program_name: item.program_name,
          program_image: item.program_image,
          program_tag: item.program_tag,
          active:
            this.programs &&
            !!this.programs.find(
              activity => activity.program_tag === item.program_tag,
            ),
        };
        if (!tempPrograms[category]) {
          tempPrograms[category] = [tempProgram];
        } else {
          tempPrograms[category].push(tempProgram);
        }
      });
      return tempPrograms;
    },
  },
  methods: {
    loadPrograms() {
      this.$store.dispatch('mirror/getPrograms');
    },
    openMirror(place, program_tag) {
      this.sendMirrorAnalytics(place, program_tag);
      this.$router.push({
        name: 'mirror',
        params: {
          place,
          program_tag,
        },
      });
    },
    sendMirrorAnalytics(place, program_tag) {
      this.$store.dispatch('analyticsEvent', {
        category: categories.mirror,
        action: actions.programListClicked,
        label: `${place}-${program_tag}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';

.mirror-wrapper {
  background-color: $color-white;
  height: 100%;
  background-color: $color-background;

  .products {
    padding: 100px 40px 64px;

    @include for-size(desktop-down) {
      padding: 100px 0 64px 0;
    }
    .header {
      padding: 0 16px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      width: 100%;

      .header-title {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0 8px 0;
        flex: 2;
        font-family: 'globotipo' !important;
        font-weight: 500 !important;
        font-size: 1.2em !important;
        font-style: italic;
        line-height: 1em;
        color: $color-black-64;
      }

      .header-date {
        flex: 1;
        margin: -4px 0 0 0;
        text-align: right;
        font-size: 0.64em;
        font-family: 'globotipo' !important;
        font-weight: 600 !important;
        color: $color-primary;
        text-transform: uppercase;
      }
    }
    .mirror-panels {
      padding: 0 16px;

      .place-title {
        font-family: 'globotipo' !important;
        font-weight: 500 !important;
      }

      .v-expansion-panel {
        border: 1px solid $color-background;

        ::v-deep .v-expansion-panel-header--active {
          min-height: 48px;
        }
        ::v-deep .v-expansion-panel-content__wrap {
          padding: 0;
        }
      }

      .products-list {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        width: 100%;
        margin: 0;
        padding: 8px 0 0 8px;
        list-style: none;

        .products-list-item {
          display: flex;
          flex-flow: wrap column;
          flex: 0 0 auto;
          width: 124px;
          height: auto;
          margin: 0 8px 0 0;
          padding: 0;
          border-radius: 4px;
          background-color: $color-white;
          box-shadow: 0 4px 8px 0 rgba($color-black, 0.04);
          overflow: hidden;

          .product-thumb {
            height: 188px;
            background-color: $color-black-08;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              background-size: cover;
            }
          }

          .product-name {
            padding: 8px;
            height: auto;
            font-size: 0.8em;
            font-family: 'globotipo' !important;
            font-weight: 600 !important;
          }

          // Remover a linha do último item
          &:last-child {
            border: none;
          }

          &.product-list-item--active {
            .v-btn {
              span {
                color: $color-black-80;
              }
            }
          }
        }
      }
    }
  }
}
</style>
